import Axios from "axios";
import {AUTH_CREDENTIALS_NAME, APIURL} from "./../Constantes";

const getCabecera = () =>{
    let Token = localStorage.getItem(AUTH_CREDENTIALS_NAME);
    let cabecera = { Authorization: `bearer ${Token}`,
    "Content-Type": "application/json",
    Accept: "application/json",}
    return cabecera;
}

const urlDuck = "Hotel";

const dataInicial = {
  array: [],
  exito: 0,
  objeto: {},
};

const GET_HOTELES_ALL = "GET_HOTELES_ALL";
const GET_HOTELES_BY_PAQUETE = "GET_HOTELES_BY_PAQUETE";
const GET_HOTELES_CLEAR_STATE = "GET_HOTELES_CLEAR_STATE";
const POTS_HOTELES_ALTA = "POTS_HOTELES_ALTA";
const DELETE_HOTELES_BY_PAQUETE = "DELETE_HOTELES_BY_PAQUETE";

export default function hotelesReducer (state = dataInicial, action) {
  switch (action.type) {
    case DELETE_HOTELES_BY_PAQUETE:
      return { ...state, exito: action.payload.exito };
    case POTS_HOTELES_ALTA:
      return { ...state, exito: action.payload.exito };
    case GET_HOTELES_ALL:
      return { ...state, array: action.payload.array };
    case GET_HOTELES_BY_PAQUETE:
      return { ...state, array: action.payload.array };
    case GET_HOTELES_CLEAR_STATE: 
      return {...state, array: action.payload.array, exito: action.payload.exito, objeto: action.payload.objeto}
    default:
      return state;
  }
}
export const eliminarHotelPaqueteAction = (idPaquete, idHotel) => async (dispatch) => {
  try {
    const respuesta = await Axios.delete(`${APIURL}/${urlDuck}/Package/${idPaquete}/${idHotel}`,
    {
        headers: getCabecera()
    });
    dispatch({
        type: DELETE_HOTELES_BY_PAQUETE,
        payload: {
            exito: 1
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};
export const altaHotelCatalogAction = (payload) => async (dispatch) =>{
  try {
    const respuestaPost = await Axios.post(`${APIURL}/${urlDuck}/Add`, payload,
    {
        headers: getCabecera()
    });
    dispatch({
        type: POTS_HOTELES_ALTA,
        payload: {
            exito: 1
        }
    })
    return respuestaPost;
  } catch (error) {
    return error;
  }
}
export const obtenerHotelesByIdPaqueteAction = (IdPaquete) => async (dispatch) => {
  try {
    const respuesta = await Axios.get(`${APIURL}/${urlDuck}/Package/${IdPaquete}`,
    {
        headers: getCabecera()
    });
    dispatch({
        type: GET_HOTELES_BY_PAQUETE,
        payload: {
            array: respuesta.data
        }
    })
    return respuesta;
  } catch (error) {
    return error;
  }
};

export const clearHotelesState = () => async (dispatch) =>{
    dispatch({
        type: GET_HOTELES_CLEAR_STATE,
        payload :{
          array: [],
          exito: 0,
          objeto: {}
        }
    })
}
